﻿(function (document, window, Iodine) {

  window.ValidateIodineGroup = function (validationGroup) {
    var isValid = true;
    document.querySelectorAll('input[data-rules][data-validation-group="' + validationGroup + '"], select[data-rules][data-validation-group="' + validationGroup + '"]')
      .forEach(function (element) {
        var inputType = element.tagName.toString().toLowerCase();
        var inputValue = inputType === "input" ?
          element.value : element.options[element.selectedIndex].value;
        var result = Iodine.is(inputValue, JSON.parse(element.dataset.rules));

        if (result !== true) {
          element.classList.add("invalid");
          var validationMessage = JSON.parse(element.dataset.validationMessage)[result] || 'Error';
          forEachSibling(element, function (sibling) {
            if (sibling.classList.contains('validation-message')) {
              sibling.innerText = validationMessage;
              sibling.style.display = 'block';
            }
          });
          isValid = false;
        }
        else {
          element.classList.remove('invalid');
          forEachSibling(element, function (sibling) {
            if (sibling.classList.contains('validation-message')) {
              sibling.innerText = '';
              sibling.style.display = 'none';
            }
          });
        }
      });

    return isValid;
  };
  function forEachSibling(input, action) {
    var list = input.parentNode.children;
    for (var i = 0; i < list.length; i++) {
      action(list[i]);
    }
  }

  document.querySelectorAll('input[data-rules], select[data-rules]').forEach(function (input) {
    input.insertAdjacentHTML('afterend', '<div class="validation-message"></div>');
  });

  document.querySelectorAll('[data-validate]').forEach(function (button) {
    button.addEventListener('click', function (e) {
      var validationGroup = button.dataset.validationGroup;
      if (!window.ValidateIodineGroup(validationGroup)) {
        e.preventDefault();
      }
    });
  });

})(document, window, Iodine);